<div class="field-dialog__content__scroll comments" fxLayout="column">
  <div
    class="comments__body p-24"
    fxLayout="column"
    #commentBody
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolledUp)="onScroll()"
  >
    <div class="p-24" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
      <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
      {{ 'MAINTENANCES.TABS.COMMENTS.LOADING' | translate }}
    </div>

    <div *ngIf="!comments.length" fxLayout="column" fxLayoutAlign="center center">
      <p fxFlex="100">
        <mat-icon class="comments__no-results-icon">comment</mat-icon>
      </p>
      <div fxFlex="100">
        <span class="h3">{{ 'MAINTENANCES.TABS.COMMENTS.NO_COMMENTS' | translate }}</span>
      </div>
    </div>

    <div *ngIf="comments.length">
      <div
        *ngFor="let comment of comments | orderBy: 'createdAt'"
        class="comments__body__message mb-16"
        [ngClass]="isMe(comment) ? 'comments__body__message__mine' : 'comments__body__message mb-16'"
      >
        <img
          class="comments__body__message__image"
          [src]="comment.postedBy.avatarUrl || 'assets/images/avatars/avatar.jpg'"
        />

        <div fxLayout="column">
          <div class="comments__body__message__content">
            <div
              [class.mine]="isMe(comment)"
              style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start"
            >
              <div class="message-type">
                <span class="message-name" [innerHTML]="getPostedByName(comment)"> </span>
                <span class="message-recipient" fxLayout="row" fxLayoutAlign="{{ isMe(comment) ? 'end' : 'start' }}">
                  {{ comment.type | sentToIdentifyComment: accountName:isMe(comment):comment.postedBy.type }}</span
                >
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="{{ isMe(comment) ? 'end' : 'start' }}">
              <button *ngIf="isMe(comment) && !comment.archived" mat-icon-button [matMenuTriggerFor]="remove">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #remove xPosition="before" yPosition="above">
                <button mat-menu-item (click)="removeComment(comment)">Excluir</button>
              </mat-menu>

              <div *ngIf="!comment.archived" [ngClass]="isMe(comment) ? 'message-text mr-8' : 'message-text'">
                {{ comment.message }}
              </div>

              <div
                *ngIf="comment.archived"
                [ngClass]="isMe(comment) ? 'message-text italic mr-8' : 'message-text italic'"
              >
                {{ 'MAINTENANCES.TABS.COMMENTS.DELETED_COMMENT' | translate }}
              </div>
            </div>
          </div>

          <div class="comments__body__message__time" fxLayoutAlign="{{ isMe(comment) ? 'end' : 'start' }}">
            <span
              [matTooltipPosition]="isMe(comment) ? 'left' : 'right'"
              matTooltip="{{ comment.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}"
              [ngClass]="isMe(comment) ? 'message-time mine' : 'message-time'"
            >
              {{ comment.createdAt | fromNow }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="comments__footer">
    <div class="comments-box-area" fxLayout="column">
      <form [formGroup]="commentForm">
        <textarea
          (keydown)="onKeydownEvent($event)"
          matInput
          #commentTextArea
          class="message-text-area"
          formControlName="message"
          placeholder="{{ 'MAINTENANCES.TABS.COMMENTS.TYPE_HERE' | translate }}"
        ></textarea>

        <div class="buttons-area" fxLayout="row" fxLayoutAlign="space-between">
          <div fxLayout="row" fxFlex="70" fxFlex.xs="100" class="align-items-center">
            <p class="visualization-label">
              {{ 'MAINTENANCES.TABS.COMMENTS.VISUALIZATION' | translate }}
            </p>

            <mat-select formControlName="type" [(value)]="selected">
              <mat-select-trigger>
                <div *ngIf="selected === 'internal'">
                  <mat-icon class="mr-10">group</mat-icon>
                  <span>{{ 'MAINTENANCES.TABS.COMMENTS.TYPE.INTERNAL' | translate }}</span>
                </div>
                <div *ngIf="selected === 'company'">
                  <mat-icon class="mr-10">business</mat-icon>
                  {{ ('MAINTENANCES.TABS.COMMENTS.TYPE.COMPANY' | translate) + fieldAccountName }}
                </div>
                <div *ngIf="selected === 'collaborator'">
                  <mat-icon class="mr-10">engineering</mat-icon>
                  {{ ('MAINTENANCES.TABS.COMMENTS.TYPE.COLLABORATOR' | translate) + fieldAccountName }}
                </div>
              </mat-select-trigger>
              <mat-option value="internal">
                <mat-icon>group</mat-icon>
                {{ 'MAINTENANCES.TABS.COMMENTS.TYPE.INTERNAL' | translate }}
              </mat-option>
              <mat-option value="company">
                <mat-icon>business</mat-icon>
                {{ ('MAINTENANCES.TABS.COMMENTS.TYPE.COMPANY' | translate) + fieldAccountName }}
              </mat-option>
              <mat-option value="collaborator">
                <mat-icon>engineering</mat-icon>
                {{ ('MAINTENANCES.TABS.COMMENTS.TYPE.COLLABORATOR' | translate) + fieldAccountName }}
              </mat-option>
            </mat-select>
          </div>

          <button
            [matTooltipPosition]="'left'"
            matTooltip="{{ 'MAINTENANCES.TABS.COMMENTS.CTRL_ENTER_TO_SEND' | translate }}"
            mat-icon-button
            type="submit"
            class="btn-send"
            (click)="addComment()"
            [disabled]="commentForm.invalid || isLoading"
          >
            <i class="angularjs-fuse-icon icon-send" [class.send-icon-color]="commentForm.valid"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
